import { render, staticRenderFns } from "./fault-detail.vue?vue&type=template&id=0270420e&scoped=true&"
import script from "./fault-detail.vue?vue&type=script&lang=js&"
export * from "./fault-detail.vue?vue&type=script&lang=js&"
import style0 from "./fault-detail.vue?vue&type=style&index=0&id=0270420e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0270420e",
  null
  
)

export default component.exports